

































import { Component, Mixins } from 'vue-property-decorator';
import { Actions, Mutations, Buttons } from '@/ts/store/Constants';
import { mapGetters } from 'vuex';
import EventLogMethods from '@/mixins/EventLogMethods.vue';
import DateMethods from '@/mixins/DateMethods.vue';
import { setScroll } from '@/plugins/save-position';

@Component({
    computed: {
        ...mapGetters({
            eventLogs: 'EventLogs/getEventLogs',
        }),
    },
})
export default class UserEventLogs extends Mixins(EventLogMethods, DateMethods) {
    public hiddenEventLogTypes: string[] = [
        'EVENT_COMMENT_NEW',
        'NOTIFICATION_COMMENT_NEW',
    ];

    constructor() {
        super();
    }

    public logClick(logId: number) {
        this.$store.dispatch(Actions.MAKE_EVENT_LOG_SEEN, logId);
    }

    public beforeCreate() {
        this.$store.commit(Mutations.SET_LEFT_HEADER_BUTTON, Buttons.StaffLanguageButton);
    }

    public created() {
        this.$store.dispatch(Actions.FETCH_EVENT_LOGS, { withExceptions: false, additionalExceptions: this.hiddenEventLogTypes });
        this.$store.dispatch(Actions.FETCH_ALL_USER_TICKETS, { vue: this, type: 'my' });
    }

    public mounted() {
        setScroll('hoc-adminapp-dashboard', 'getStaffAppPagePosition');
    }
}
